export default "__VITE_ASSET__DtSPkleh__"